/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";

const Dialog = require("@react/react-spectrum/Dialog").default;

class WarningDialog extends Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    return (
      <Dialog
        title={formatMessage({
          id: "dialog.submitAction.warning.title"
        })}
        onConfirm={this.props.onConfirm}
        onCancel={this.props.cancelDialog}
        confirmLabel={formatMessage({ id: "dialog.submitAction.warning.connect" })}
        cancelLabel={formatMessage({ id: "common.cancel" })}
        autoFocusButton="confirm"
        trapFocus
      >
        <p>
          {formatMessage(
            {
              id: "dialog.submitAction.warning.text"
            },
            {
              url: this.props.url
            }
          )}
        </p>
      </Dialog>
    );
  }
}

export { WarningDialog };
